<template>
	<div class="pick-up-time-modal modal">
		<pick-up-time-picker
			:pick-up-time="pickUpTime"
			:pick-up-time-from="pickUpTimeFrom"
			:pick-up-time-to="pickUpTimeTo"
			:is-static="true"
			:dark-theme="darkTheme"
			@click.stop
			@change-time="changePickUpTime"
			@cancel="cancel"
			@close="close"
		/>
	</div>
</template>

<script>
import PickUpTimePicker from '@/viewsOM/Cart/PickUpTimePicker'

export default {
	name: 'PickUpTimeModal',

	components: { PickUpTimePicker },

	props: {
		pickUpTime: {
			type: Object,
			default: () => {}
		},

		pickUpTimeFrom: {
			type: String,
			default: ''
		},

		pickUpTimeTo: {
			type: String,
			default: ''
		},

		darkTheme: {
			type: Boolean,
			default: true
		}
	},

	methods: {
		changePickUpTime({ pickUpTimeFrom, pickUpTimeTo }) {
			this.$emit('change-pick-up-time', { pickUpTimeFrom, pickUpTimeTo })
			this.close()
		},

		cancel() {
			this.$emit('cancel')
		},

		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.pick-up-time-modal {
	.time-picker-holder {
		display: inline-block;
		width: 100%;
		text-align: center;
		vertical-align: middle;
		white-space: normal;
	}

	.time-picker {
		display: inline-block;
		position: static;
		bottom: 0;
		max-width: 100%;

		&:after {
			display: none;
		}
	}
}
</style>
